import { render, staticRenderFns } from "./Webinars.vue?vue&type=template&id=4bcc8f6a&scoped=true"
import script from "./Webinars.vue?vue&type=script&lang=js"
export * from "./Webinars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc8f6a",
  null
  
)

export default component.exports